import * as React from "react";
import {useState} from "react";
import BOListTemplates from "../DocumentTemplates/bolisttemplates";
import DocuTemplates from "../DocumentTemplates/docutemplates";
import ButtonNavigation from "../BottomNavigation/bottomNavigation";
import {displayCountryDesc} from '../Services/services';
import LegalDisclaimerTexts from "./legalDisclaimerTexts"

interface Props {
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  selectedPage: string;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  country: string;
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>;
  selectedOption: string;    
}

const Acknowledgement: React.FC<Props> = (props) => {
  const {
    setSelectedCountry,
    country,
    setSelectedOption,
    selectedOption,
    setSelectedPage,
    selectedPage,
  } = props;

  const[agree, setAgree] = useState(false);

  const handleClick = () => {
    setAgree(!agree);
  }

  return (
    <div>
      <div style={{ marginTop: "10px" }}>
        Upload Beneficial Owner List - Step 3
      </div>

      <div style={{ marginTop: "10px" }}>
        {displayCountryDesc(country, selectedOption)}
      </div>

      <div className="inline" style={{ marginRight: "15px" }}>
        <BOListTemplates country={country} />
        <DocuTemplates country={country} />
      </div>

      <div className="inline" style={{ width: "65%" }}>
        <div className="subTitle" style={{ marginTop: "10px" }}>
          Acknowledgement and Legal Disclaimer
        </div>
        <br/>
        <div>
          The 'Continue' button will become active after you select 'I agree'.
        </div>
        <br/>        
        <div
          style={{
            height: "200px",
            overflow: "auto",
            borderWidth: "2px",
            borderStyle: "inset",
            borderColor: "black",
            padding: "5px",
          }}
        >
          <LegalDisclaimerTexts country={country} selectedOption={selectedOption} />
        </div>

        <div
          style={{
            backgroundColor: "#F1F0F0",
            paddingTop: "5px",
            paddingBottom: "5px",
            marginTop: "20px",
            textAlign: "end",
          }}
        >
          <div style={{ paddingTop: "5px", marginRight: "5px" }}>
            <label className="checkbox-label">
              <input type="checkbox" onClick={handleClick}/>I Agree
            </label>
          </div>
        </div>

        <ButtonNavigation
          setSelectedPage={setSelectedPage}
          selectedPage={selectedPage}
          setSelectedCountry={setSelectedCountry}
          country={country}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          agree={agree}
        />
      </div>
    </div>
  );
};

export default Acknowledgement;
